import axios from 'axios';
import useAgent from '../../hooks/useAgent';
import url from './url';

const attachmentsUrl = (id) => `${url}/${id}/attachments`;

const getTransactionAttachments = (id) => axios.get(attachmentsUrl(id));

const useGetTransactionAttachments = () => useAgent(getTransactionAttachments);

export default useGetTransactionAttachments;
